import { render, staticRenderFns } from "./Aliado_n.vue?vue&type=template&id=4c6f5562&"
import script from "./Aliado_n.vue?vue&type=script&lang=js&"
export * from "./Aliado_n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports